/* Freshbliss - replacement page mobile patch - 30 Oct 2026
   Compresses photos on the phone, caps the upload, adds timeout and retry,
   and stops the form reloading the page. Inert on pages without #fb-form. */
(function () {
  if (window.__fbRepPatch) return;
  window.__fbRepPatch = true;

  var MAX_PHOTOS = 4;
  var MAX_EDGE = 1600;
  var TARGET_BYTES = 900000;
  var TOTAL_BUDGET = 4200000;
  var TIMEOUT_MS = 60000;

  function setNote(text, state) {
    var n = document.querySelector('.fb-rep__photo-note');
    if (!n) return;
    n.textContent = text || '';
    if (state) n.setAttribute('data-state', state);
    else n.removeAttribute('data-state');
  }

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (url.indexOf('script.google') === -1) return nativeFetch(input, init);
      function attempt(n) {
        var ctl = ('AbortController' in window) ? new AbortController() : null;
        var opts = {};
        for (var k in (init || {})) opts[k] = init[k];
        if (ctl && !opts.signal) opts.signal = ctl.signal;
        var timer = ctl ? setTimeout(function () { ctl.abort(); }, TIMEOUT_MS) : null;
        return nativeFetch(input, opts).then(function (r) {
          if (timer) clearTimeout(timer);
          return r;
        }).catch(function (err) {
          if (timer) clearTimeout(timer);
          if (n > 0) {
            setNote('Connection dropped. Trying once more', 'busy');
            return new Promise(function (res) { setTimeout(res, 1200); }).then(function () { return attempt(n - 1); });
          }
          throw err;
        });
      }
      return attempt(1);
    };
  }

  function start() {
    var form = document.getElementById('fb-form');
    if (!form) return;

    var fileInput = form.querySelector('input[type="file"]');
    var busy = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) {
        e.stopImmediatePropagation();
        setNote('Still preparing your photos. One moment', 'busy');
      }
    }, true);

    if (!fileInput) return;

    var strip = document.createElement('div');
    strip.className = 'fb-rep__photo-strip';
    var note = document.createElement('p');
    note.className = 'fb-rep__photo-note';
    fileInput.parentNode.insertBefore(strip, fileInput.nextSibling);
    fileInput.parentNode.insertBefore(note, strip.nextSibling);

    function setSubmitBusy(state) {
      var btn = form.querySelector('.fb-rep__btn') || form.querySelector('[type="submit"]');
      if (!btn) return;
      if (state) { btn.setAttribute('data-fb-wait', '1'); btn.disabled = true; }
      else if (btn.getAttribute('data-fb-wait')) { btn.removeAttribute('data-fb-wait'); btn.disabled = false; }
    }

    function readAsImage(file) {
      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () { resolve({ img: img, url: url }); };
        img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
        img.src = url;
      });
    }

    function toBlob(canvas, quality) {
      return new Promise(function (resolve) {
        if (canvas.toBlob) canvas.toBlob(function (b) { resolve(b); }, 'image/jpeg', quality);
        else {
          var d = canvas.toDataURL('image/jpeg', quality);
          var bin = atob(d.split(',')[1]);
          var arr = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
          resolve(new Blob([arr], { type: 'image/jpeg' }));
        }
      });
    }

    function compress(file, index) {
      return readAsImage(file).then(function (o) {
        var img = o.img;
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
        var cw = Math.max(1, Math.round(w * scale));
        var ch = Math.max(1, Math.round(h * scale));
        var canvas = document.createElement('canvas');
        canvas.width = cw; canvas.height = ch;
        canvas.getContext('2d').drawImage(img, 0, 0, cw, ch);
        URL.revokeObjectURL(o.url);
        var qualities = [0.72, 0.6, 0.48, 0.38];
        var step = function (i) {
          return toBlob(canvas, qualities[i]).then(function (blob) {
            if (!blob) throw new Error('encode');
            if (blob.size <= TARGET_BYTES || i === qualities.length - 1) return blob;
            return step(i + 1);
          });
        };
        return step(0).then(function (blob) {
          var name = (file.name || ('photo-' + (index + 1))).replace(/\.[^.]+$/, '') + '.jpg';
          try { return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }); }
          catch (e) { blob.name = name; return blob; }
        });
      });
    }

    function render(files) {
      strip.innerHTML = '';
      Array.prototype.forEach.call(files, function (f) {
        var d = document.createElement('div');
        d.className = 'fb-rep__photo-thumb';
        var im = document.createElement('img');
        im.src = URL.createObjectURL(f);
        im.onload = function () { URL.revokeObjectURL(im.src); };
        d.appendChild(im);
        strip.appendChild(d);
      });
    }

    var guard = false;
    fileInput.addEventListener('change', function () {
      if (guard) { guard = false; return; }
      var picked = Array.prototype.slice.call(fileInput.files || []);
      if (!picked.length) { strip.innerHTML = ''; setNote(''); return; }

      var trimmed = picked.slice(0, MAX_PHOTOS);
      var dropped = picked.length - trimmed.length;

      busy = true;
      setSubmitBusy(true);
      setNote('Preparing ' + trimmed.length + ' photo' + (trimmed.length > 1 ? 's' : '') + ' for upload', 'busy');

      var out = [];
      var chain = Promise.resolve();
      trimmed.forEach(function (f, i) {
        chain = chain.then(function () {
          setNote('Preparing photo ' + (i + 1) + ' of ' + trimmed.length, 'busy');
          return compress(f, i).then(function (nf) { out.push(nf); }).catch(function () { out.push(f); });
        });
      });

      chain.then(function () {
        var total = out.reduce(function (s, f) { return s + f.size; }, 0);
        while (out.length > 1 && total > TOTAL_BUDGET) {
          total -= out.pop().size;
          dropped++;
        }
        try {
          var dt = new DataTransfer();
          out.forEach(function (f) { dt.items.add(f); });
          guard = true;
          fileInput.files = dt.files;
        } catch (e) {}
        render(fileInput.files);
        var mb = (total / 1048576).toFixed(1);
        var msg = out.length + ' photo' + (out.length > 1 ? 's' : '') + ' ready, ' + mb + ' MB total';
        if (dropped > 0) msg += '. ' + dropped + ' extra photo' + (dropped > 1 ? 's were' : ' was') + ' left out, ' + MAX_PHOTOS + ' is the maximum';
        busy = false;
        setSubmitBusy(false);
        setNote(msg);
      }).catch(function () {
        busy = false;
        setSubmitBusy(false);
        setNote('Those photos could not be prepared. Try picking them again, or send fewer', 'error');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
